var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subject",style:({ 'max-width': _vm.mainWidth + 'px' }),attrs:{"id":"subject"}},[_c('div',{staticClass:"editortitle"},[_vm._v("详细信息")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }